import { Matrix3d, IMatrix3dValue } from "../geom/Matrix3d.js";

/**
 * @see https://github.com/greensock/GreenSock-JS/blob/master/src/uncompressed/plugins/TEMPLATE_Plugin.js
 */
var transformPluginMatrix = new Matrix3d();

interface TweenMatrix3dData {
    _valuesStart: IMatrix3dValue;
    _valuesEnd: IMatrix3dValue;
    _valuesChange: IMatrix3dValue;
    _target: HTMLElement;
}

export var TweenMatrix3d: gsap.RegisterablePlugins = {
    name: "matrix3d",
    version: "2.0.0",
    rawVars: 1,
    overwriteProps: ["transform", "x", "y", "z", "scaleX", "scaleY", "skewX", "skewY", "rotation", "rotationX", "rotationY", "rotationZ"],
    init: function (target: any, value: Matrix3d | string, tween: gsap.core.Tween, index: number, targets: any) {
        var data = (this as any) as TweenMatrix3dData;

        data._target = target;


        var style: CSSStyleDeclaration = tween.vars.style || window.getComputedStyle(target);
        if (typeof value === "string")
            transformPluginMatrix.setCss(value);
        else
            transformPluginMatrix.copyFrom(value);
        var valuesEnd: any = transformPluginMatrix.copyTo();
        data._valuesEnd = valuesEnd;

        transformPluginMatrix.setCss(style.transform);
        var valuesStart: any = transformPluginMatrix.copyTo();
        data._valuesStart = valuesStart;

        var valuesChange: any = {};
        for (var p in valuesEnd) {
            valuesChange[p] = valuesEnd[p] - valuesStart[p];
        }
        data._valuesChange = valuesChange;
        return true;
    },

    render: function (ratio: number, d) {
        var data: TweenMatrix3dData = d as any;
        for (var p in data._valuesEnd) {
            var k = p as keyof IMatrix3dValue;
            data._valuesEnd[k] = data._valuesStart[k] + data._valuesChange[k] * ratio;
        }
        transformPluginMatrix.copyFrom(data._valuesEnd);
        data._target.style.transform = transformPluginMatrix.getCss3d();
    }
};

gsap.registerPlugin(TweenMatrix3d);